<template>
    <div class="main-page">
        <hero-main />
        <ink-about :slides="inkAboutSlidesArray?.[lang]"/>
        <projects-block :projects="projectsList"/>
        <missions-section :projects="missionSectionCardsArray?.[lang]"/>
        <programs-section :cardList="programsSectionCardsArray?.[lang]"/>
        <vacancy-section
            theme="light"
            :use-container="true"
        />
        <main-modal-banner v-if="lang === 'ru'"/>
    </div>
</template>

<script setup>
import HeroMain from './components/HeroMain';
import InkAbout from './components/InkAbout';
import MainModalBanner from './components/MainModalBanner';
import ProjectsBlock from './components/ProjectsBlock';
import ProgramsSection from './components/ProgramsSection';
import MissionsSection from './components/MissionsSection';
import VacancySection from '../global/VacancySection'

import {
    inkAboutSlidesArray,
    missionSectionCardsArray,
    programsSectionCardsArray,
} from './composable/useLocalize';

import { useGetter } from '@/composable/useGetter'
import { computed } from 'vue'

const { lang, app } = useGetter(['lang', 'app'])

const projectsList = computed(() => app.value?.components?.projects_main?.items || [])

</script>

<style lang="scss">
.main-page {
    & .vacancy-section{
        margin-top: -3.689%;
        background: url(/local/templates/z-template/images/vacancy-section-bg-20260414.jpg) no-repeat;
        background-size: cover;
    }
}
</style>
